const initialStyles = {
    backgroundColor: '',
    secondaryBackgroundColor: '',
    headerBackgroundColor: '',
    headerTextColor: '',
    subheaderTextColor: '#555',
    textColor: '',
    headerFontSize: '1.6',
    subheaderFontSize: '1',
    bodyFontSize: '1',
};

export default initialStyles;

